webpackJsonp([273666453351901],{

/***/ 785:
/***/ (function(module, exports) {

	module.exports = {
	  "key": "style-libraries",
	  "name": "Style Libraries",
	  "description": "Tools that assist you with applying CSS to your components or HTML.",
	  "aka": [
	    "css processors",
	    "style utilities",
	    "stylers"
	  ],
	  "tags": [
	    {
	      "name": "css processor",
	      "description": "Converts another language into CSS or modifies/improves CSS."
	    },
	    {
	      "name": "inline",
	      "description": "Works by setting styles in JavaScript rather than in a separate style file."
	    },
	    {
	      "name": "react",
	      "description": "Works only with React or mentions specifically that it works well with React."
	    }
	  ],
	  "articles": [],
	  "projects": [
	    {
	      "githubPath": "Khan/aphrodite",
	      "description": "Framework-agnostic CSS-in-JS with support for server-side rendering, browser prefixing, and minimum CSS generation",
	      "homepage": "",
	      "dependencies": null,
	      "tags": [],
	      "lastStarCount": 4252,
	      "lastUpdatedAt": "2018-07-26T14:45:13Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/15455?v=4"
	    },
	    {
	      "githubPath": "adamterlson/cairn",
	      "description": "Hierarchical shared and component-based style definitions with selector-based style application, for React Native",
	      "homepage": "",
	      "dependencies": null,
	      "tags": [],
	      "lastStarCount": 109,
	      "lastUpdatedAt": "2018-07-19T09:52:36Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/2498418?v=4"
	    },
	    {
	      "githubPath": "blakeembrey/react-free-style",
	      "description": "Make React components easier and more maintainable by using inline style objects",
	      "homepage": "",
	      "dependencies": null,
	      "tags": [
	        "react"
	      ],
	      "lastStarCount": 120,
	      "lastUpdatedAt": "2018-07-25T16:01:44Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/1088987?v=4"
	    },
	    {
	      "githubPath": "casesandberg/reactcss",
	      "description": ":lipstick: Inline Styles in JS",
	      "homepage": "http://reactcss.com/",
	      "dependencies": null,
	      "tags": [
	        "inline",
	        "react"
	      ],
	      "lastStarCount": 1504,
	      "lastUpdatedAt": "2018-07-27T18:48:58Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/4633636?v=4"
	    },
	    {
	      "githubPath": "css-modules/css-modules",
	      "description": "Documentation about css-modules",
	      "homepage": null,
	      "dependencies": null,
	      "tags": [
	        "react"
	      ],
	      "lastStarCount": 10183,
	      "lastUpdatedAt": "2018-07-27T17:53:28Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/12612655?v=4"
	    },
	    {
	      "githubPath": "FormidableLabs/radium",
	      "description": "A toolchain for React component styling.",
	      "homepage": "http://formidable.com/open-source/radium/",
	      "dependencies": null,
	      "tags": [
	        "inline"
	      ],
	      "lastStarCount": 6447,
	      "lastUpdatedAt": "2018-07-27T16:58:41Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/5078602?v=4"
	    },
	    {
	      "githubPath": "gajus/react-css-modules",
	      "description": "Seamless mapping of class names to CSS modules inside of React components.",
	      "homepage": "",
	      "dependencies": null,
	      "tags": [
	        "react"
	      ],
	      "lastStarCount": 4703,
	      "lastUpdatedAt": "2018-07-27T14:42:24Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/973543?v=4"
	    },
	    {
	      "githubPath": "iamvdo/pleeease",
	      "description": "Process CSS with ease: combine preprocessors and PostCSS",
	      "homepage": "http://pleeease.io",
	      "dependencies": null,
	      "tags": [
	        "css processor"
	      ],
	      "lastStarCount": 473,
	      "lastUpdatedAt": "2018-07-26T12:37:51Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/1260529?v=4"
	    },
	    {
	      "githubPath": "cssinjs/jss",
	      "description": "JSS is an authoring tool for CSS which uses JavaScript as a host language.",
	      "homepage": "http://cssinjs.org",
	      "dependencies": null,
	      "tags": [],
	      "lastStarCount": 3853,
	      "lastUpdatedAt": "2018-07-27T10:16:57Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/9503099?v=4"
	    },
	    {
	      "githubPath": "less/less.js",
	      "description": "Less. The dynamic stylesheet language.",
	      "homepage": "http://lesscss.org",
	      "dependencies": null,
	      "tags": [
	        "css processor"
	      ],
	      "lastStarCount": 15641,
	      "lastUpdatedAt": "2018-07-27T21:05:03Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/3538330?v=4"
	    },
	    {
	      "githubPath": "maxguzenski/react-easy-style",
	      "description": "A tiny library to easy apply css/styles to react components",
	      "homepage": "",
	      "dependencies": null,
	      "tags": [
	        "react"
	      ],
	      "lastStarCount": 79,
	      "lastUpdatedAt": "2017-11-09T14:35:01Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/6819?v=4"
	    },
	    {
	      "githubPath": "paypal/glamorous",
	      "description": "💄 Maintainable CSS with React",
	      "homepage": "https://glamorous.rocks",
	      "dependencies": null,
	      "tags": [
	        "inline"
	      ],
	      "lastStarCount": 3657,
	      "lastUpdatedAt": "2018-07-27T18:51:06Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/476675?v=4"
	    },
	    {
	      "githubPath": "jsxstyle/jsxstyle",
	      "description": "Inline style system for React and Preact",
	      "homepage": "",
	      "dependencies": null,
	      "tags": [
	        "inline"
	      ],
	      "lastStarCount": 1812,
	      "lastUpdatedAt": "2018-07-27T04:44:44Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/29987079?v=4"
	    },
	    {
	      "githubPath": "postcss/postcss",
	      "description": "Transforming styles with JS plugins",
	      "homepage": "https://postcss.org/",
	      "dependencies": null,
	      "tags": [
	        "css processor"
	      ],
	      "lastStarCount": 18991,
	      "lastUpdatedAt": "2018-07-27T15:58:39Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/8296347?v=4"
	    },
	    {
	      "githubPath": "rofrischmann/fela",
	      "description": "State-Driven Styling in JavaScript",
	      "homepage": "http://fela.js.org",
	      "dependencies": null,
	      "tags": [],
	      "lastStarCount": 1421,
	      "lastUpdatedAt": "2018-07-26T20:15:51Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/10060928?v=4"
	    },
	    {
	      "githubPath": "rofrischmann/react-look",
	      "description": "Advanced & Dynamic Component Styling for React and React Native. Ships with powerful Plugins, Mixins and Developer Tools. (Deprecated: use Fela)",
	      "homepage": "",
	      "dependencies": null,
	      "tags": [
	        "react"
	      ],
	      "lastStarCount": 598,
	      "lastUpdatedAt": "2018-07-27T03:15:21Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/10060928?v=4"
	    },
	    {
	      "githubPath": "sass/sass",
	      "description": "Sass makes CSS fun again.",
	      "homepage": "http://sass-lang.com",
	      "dependencies": null,
	      "tags": [
	        "css processor"
	      ],
	      "lastStarCount": 11441,
	      "lastUpdatedAt": "2018-07-27T21:05:14Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/317889?v=4"
	    },
	    {
	      "githubPath": "segmentio/myth",
	      "description": "A CSS preprocessor that acts like a polyfill for future versions of the spec.",
	      "homepage": "http://myth.io",
	      "dependencies": null,
	      "tags": [
	        "css processor"
	      ],
	      "lastStarCount": 4421,
	      "lastUpdatedAt": "2018-07-25T16:16:43Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/819518?v=4"
	    },
	    {
	      "githubPath": "styled-components/styled-components",
	      "description": "Visual primitives for the component age. Use the best bits of ES6 and CSS to style your apps without stress 💅",
	      "homepage": "https://styled-components.com",
	      "dependencies": null,
	      "tags": [
	        "react"
	      ],
	      "lastStarCount": 17914,
	      "lastUpdatedAt": "2018-07-27T19:23:59Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/20658825?v=4"
	    },
	    {
	      "githubPath": "stylus/stylus",
	      "description": "Expressive, robust, feature-rich CSS language built for nodejs",
	      "homepage": "http://stylus-lang.com/",
	      "dependencies": null,
	      "tags": [
	        "css processor"
	      ],
	      "lastStarCount": 9310,
	      "lastUpdatedAt": "2018-07-27T16:25:11Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/10009463?v=4"
	    },
	    {
	      "githubPath": "unicorn-standard/react-pacomo",
	      "description": "Automatic Namespacing for your React className props",
	      "homepage": "http://unicornstandard.com/packages/react-pacomo.html",
	      "dependencies": null,
	      "tags": [
	        "react"
	      ],
	      "lastStarCount": 194,
	      "lastUpdatedAt": "2018-05-15T11:35:39Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/14356264?v=4"
	    },
	    {
	      "githubPath": "rtsao/styletron",
	      "description": ":zap: Toolkit for component-oriented styling",
	      "homepage": "",
	      "dependencies": null,
	      "tags": [],
	      "lastStarCount": 2498,
	      "lastUpdatedAt": "2018-07-25T10:01:11Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/780408?v=4"
	    },
	    {
	      "githubPath": "zeit/styled-jsx",
	      "description": "Full CSS support for JSX without compromises",
	      "homepage": "http://npmjs.com/styled-jsx",
	      "dependencies": null,
	      "tags": [
	        "react"
	      ],
	      "lastStarCount": 3397,
	      "lastUpdatedAt": "2018-07-27T14:40:15Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/14985020?v=4"
	    },
	    {
	      "githubPath": "emotion-js/emotion",
	      "description": "style as a function of state",
	      "homepage": "https://emotion.sh/",
	      "dependencies": null,
	      "tags": [
	        "inline"
	      ],
	      "lastStarCount": 4494,
	      "lastUpdatedAt": "2018-07-27T20:49:12Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/31557565?v=4"
	    }
	  ]
	}

/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styleLibraries = __webpack_require__(785);
	
	var _styleLibraries2 = _interopRequireDefault(_styleLibraries);
	
	var _Page = __webpack_require__(10);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _ListPageContainer = __webpack_require__(18);
	
	var _ListPageContainer2 = _interopRequireDefault(_ListPageContainer);
	
	var _addNotes = __webpack_require__(43);
	
	var _addNotes2 = _interopRequireDefault(_addNotes);
	
	var _StyledTextBlock = __webpack_require__(15);
	
	var _StyledTextBlock2 = _interopRequireDefault(_StyledTextBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var extendedList = (0, _addNotes2.default)(_styleLibraries2.default, {
	  "gajus/react-css-modules": "This helps you set up CSS Modules in your project, but you don't need it to use CSS Modules with React."
	});
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _Page2.default,
	    null,
	    _react2.default.createElement(
	      _ListPageContainer2.default,
	      { list: extendedList },
	      _react2.default.createElement(
	        _StyledTextBlock2.default,
	        null,
	        _react2.default.createElement(
	          "p",
	          null,
	          "These are tools that assist with applying styles to elements. There are a variety of ways that this can happen."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "The most common type of style library is a",
	          " ",
	          _react2.default.createElement(
	            "a",
	            { href: "#tag:'css processor'" },
	            "CSS processor"
	          ),
	          ". These take as input a language similar to CSS but with more features, and output standard CSS that the browser can understand."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "The other tools are more varied. They might help you manage",
	          _react2.default.createElement(
	            "a",
	            { href: "#tag:'inline'" },
	            "inline"
	          ),
	          " styles, help you write your CSS in JavaScript, or help you keep styles isolated to a particular component."
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-list-style-libraries-js-f49a8fd54337c13c707a.js